import { RouteProp } from "@react-navigation/native";
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from "@react-navigation/native-stack";
import { PreloadedQuery } from "react-relay";

import { WTCSSelectRoutineQuery } from "./__generated__/WTCSSelectRoutineQuery.graphql";
import { WTCSSelectTasksQuery } from "./__generated__/WTCSSelectTasksQuery.graphql";

type WTCSStackParamList = {
  WTCSMain: {
    storecastId: string;
  };
  WTCSSelectTeams: object;
  WTCSSelectRoutine: {
    query: PreloadedQuery<WTCSSelectRoutineQuery>;
  };
  WTCSSelectTasks: {
    queryRef: PreloadedQuery<WTCSSelectTasksQuery>;
  };
};

export type WTCSStackScreenProps<T extends keyof WTCSStackParamList> = {
  navigation: NativeStackNavigationProp<WTCSStackParamList, T>;
  route: RouteProp<WTCSStackParamList, T>;
};

export const WTCSStack = createNativeStackNavigator<WTCSStackParamList>();
